import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_Arabic\",\"arguments\":[{\"subsets\":[\"arabic\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-noto-arabic\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"notoArabic\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_SC\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-noto-sc\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"notoSansSC\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_KR\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-noto-kr\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"notoSansKR\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/reactQuery.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/app/src/styles/error.module.scss");
